import { AnimatedSprite, Container } from 'pixi.js';
import { TextureFactory } from '../../core';
import TextureInfo from './fx.json';

class Lighting extends Container {
  public animatedSprite: AnimatedSprite;
  public complete: boolean = false;

  constructor() {
    super();

    const textures = TextureFactory.instance.load(TextureInfo);
    this.animatedSprite = new AnimatedSprite(textures);
    this.animatedSprite.loop = false;
    this.animatedSprite.animationSpeed = 0.3;
    this.animatedSprite.updateAnchor = true;
    this.animatedSprite.scale.set(5);
    this.animatedSprite.play();

    this.animatedSprite.onComplete = () => {
      this.complete = true;
    };

    this.addChild(this.animatedSprite);
  }

  public update(): void {
    if (this.complete) {
      if (this.alpha >= 0.02) {
        this.alpha -= 0.02;
      } else {
        this.alpha = 0;
        this.visible = false;
      }
    }
  }
}

export default Lighting;
